import React, { ReactNode, useCallback } from 'react';
import { StyleSheet, useStyles } from '@rexlabs/styling';

const defaultStyles = StyleSheet({
  hamburger: {
    height: 'inherit',
    display: 'flex',
    alignItems: 'center',
    '> svg': {
      width: 28,
      height: 32
    },
    '&:hover': {
      cursor: 'pointer'
    }
  }
});

interface Props {
  label?: string;
  formLocation?: string;
  resourceId?: number;
  resourceType?: string;
  paneDirection: string;
  content: ReactNode;
  backgroundColor: string;
  fontColor?: string;
  formExtraFields?: object;
  Icon: any;
  hamburgerColor: string;
  headerBackgroundColor: string;
}

export function SlideOutButton(props: Props) {
  const onClick = useCallback(() => {
    // @ts-ignore
    document.openSlideout(props);
  }, [props]);

  const s = useStyles(defaultStyles);
  const { label, Icon, hamburgerColor } = props;

  return (
    <>
      <div style={{ height: '100%' }}>
        {Icon && (
          <div
            {...s.with('hamburger')({
              color: hamburgerColor
            })}
            onClick={onClick}
          >
            <Icon width={'32px'} height={'32px'} />
          </div>
        )}

        {label && (
          <div
            className={'button'}
            onClick={onClick}
            dangerouslySetInnerHTML={{ __html: label }}
          />
        )}
      </div>
    </>
  );
}
